import { render, staticRenderFns } from "./AppTitle.vue?vue&type=template&id=484a2a00&"
import script from "./AppTitle.vue?vue&type=script&lang=js&"
export * from "./AppTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports